import { DefaultAttributesContainer } from "../containers/DefaultAttributesContainer";
import { TwoColumnsInnerContainer } from "../containers/TwoColumnsInnerContainer";
import { OneColumnContainer } from "../containers/OneColumnContainer";
import { TwoColumnContainer } from "../containers/TwoColumnContainer";
import { AttributeContainer } from "../containers/AttributeContainer";
import { ImageContainer } from "../containers/ImageContainer";
import { IconContainer } from "../containers/IconContainer";
import { ContainersGroupContainer } from "../containers/ContainersGroupContainer";
import { ChartContainer } from "../containers/ChartContainer";
import { CameraContainer } from "../containers/CameraContainer";
import { DividerContainer } from "../containers/DividerContainer";
import { DataSourceContainer } from "../containers/DataSourceContainer";
import { TitleContainer } from "../containers/TitleContainer";
import { RoundedBackgroundContainer } from "../containers/RoundedBackgroundContainer";
import { TabsContainer } from "../containers/TabsContainer";
import { FiltersContainer } from "../containers/FiltersContainer";
import { ProgressContainer } from "../containers/ProgressContainer";
import { DataSourceProgressContainer } from "../containers/DataSourceProgressContainer";
import { PagesContainer } from "../containers/PagesContainer";
import { PaginationContainer } from "../containers/PaginationContainer";
import { SlideshowContainer } from "../containers/SlideshowContainer";
import { LayersContainer } from "../containers/LayersContainer";
import { YandexMapContainer } from "../containers/YandexMapContainer";
import { AddFeatureContainer } from "../containers/AddFeatureContainer";
import { ContainerTemplate } from "../types";

export const getContainerTemplate = (templateName: ContainerTemplate) => {
  switch (templateName) {
    case ContainerTemplate.Pages:
      return PagesContainer;
    case ContainerTemplate.Pagination:
      return PaginationContainer;
    case ContainerTemplate.ContainersGroup:
      return ContainersGroupContainer;
    case ContainerTemplate.Tabs:
      return TabsContainer;
    case ContainerTemplate.OneColumn:
      return OneColumnContainer;
    case ContainerTemplate.TwoColumnsInner:
      return TwoColumnsInnerContainer;
    case ContainerTemplate.RoundedBackground:
      return RoundedBackgroundContainer;
    case ContainerTemplate.Progress:
      return ProgressContainer;
    case ContainerTemplate.TwoColumn:
      return TwoColumnContainer;
    case ContainerTemplate.Attribute:
      return AttributeContainer;
    case ContainerTemplate.Image:
      return ImageContainer;
    case ContainerTemplate.Icon:
      return IconContainer;
    case ContainerTemplate.Chart:
      return ChartContainer;
    case ContainerTemplate.DataSource:
      return DataSourceContainer;
    case ContainerTemplate.DataSourceProgress:
      return DataSourceProgressContainer;
    case ContainerTemplate.Filters:
      return FiltersContainer;
    case ContainerTemplate.Title:
      return TitleContainer;
    case ContainerTemplate.Slideshow:
      return SlideshowContainer;
    case ContainerTemplate.Camera:
      return CameraContainer;
    case ContainerTemplate.Layers:
      return LayersContainer;
    case ContainerTemplate.YandexMap:
      return YandexMapContainer;
    case ContainerTemplate.AddFeature:
      return AddFeatureContainer;
    case ContainerTemplate.Divider:
      return DividerContainer;
    default:
      return DefaultAttributesContainer;
  }
};
